<template>
  <load-content :loading="!isReady">
    <div class="container-scoring">
      <div class="containers-div" v-if="this.general.scoring == 1 || this.general.scoring == 2 || this.general.scoring == 3">
        <div class="favourability-div card" >
          <h3>Favourability</h3>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td colspan="2">
                  <h4 class="tone-class">Setup</h4>
                </td>
              </tr>
              <tr>
                <td>
                  Method
                </td>
                <td>
                  <input-select
                    id="method"
                    v-model="method"
                    :options="
                      favourability_methods.map(option => ({
                        value: option.id,
                        label: option.text
                      }))
                    "
                    :label="opt => favourability_methods.find(x => x.id == opt).text"
                    :show-labels="false"
                    :allowEmpty="false"
                    open-direction="bottom"
                    :searchable="true"
                    :onChange="onChangeSelectMethod"
                    :disabled="false"

                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="this.method == 2 || this.method == 3">
                <td>% Total Score</td>
                <td>
                  <input-text
                    :value="scoring_data.total_score"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'total_score' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr class="separator" v-show="this.method == 2 || this.method == 3">
                <td colspan="2"></td>
              </tr>
              <tr v-show="this.method == 1 || this.method == 3">
                <td>Fav Weight Increment</td>
                <td>
                  <input-text
                    :value="scoring_data.weight_increment"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'weight_increment' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr class="separator" v-show="this.method == 1 || this.method == 3">
                <td colspan="2"></td>
              </tr>
            </tbody>
          </table>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td colspan="2" v-show="scoring_data.split !== 0">
                  <h4 class="tone-class">Tone Multiplier</h4>
                </td>
              </tr>
              <tr v-show="scoring_data.split !== 0">
                <td>Split</td>
                <td>
                  <input-select
                    :id="scoring_data.split"
                    :searchable="true"
                    :options="
                      split_scoring.map(option => ({
                        value: option.id,
                        label: option.text
                      }))
                    "
                    :custom-label="opt => splitCustomLabel(opt)"
                    :show-labels="false"
                    :allowEmpty="false"
                    open-direction="bottom"
                    :selectedValue="scoring_data.split"
                    :onChange="onChangeSelectSplit"
                    :disabled="false"
                  />
                </td>
              </tr>
              <tr class="separator" v-show="scoring_data.split !== 0">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true">
                <td>Positive</td>
                <td>
                  <input-text
                    :value="scoring_data.positive"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'positive' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr v-show="showSplitInputs == true && neutralSplit == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true && neutralSplit == true">
                <td>Neutral</td>
                <td>
                  <input-text
                    :value="scoring_data.neutral"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'neutral' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr v-show="hideSplitInputs == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="hideSplitInputs == true">
                <td>Balanced</td>
                <td>
                  <input-text
                    :value="scoring_data.balanced"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'balanced' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr v-show="showSplitInputs == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true">
                <td>Negative</td>
                <td>
                  <input-text
                    :value="scoring_data.negative"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'negative' }"
                    :readOnly=false
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="scoring-constants card">
          <h3>Scoring Constants</h3>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td>Multiplier</td>
                <td>
                  <input-text
                    :value="scoring_data.multiplier"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'multiplier' }"
                    :readOnly=false
                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr>
                <td>Offset</td>
                <td>
                  <input-text
                    :value="scoring_data.offset"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'offset' }"
                    :readOnly=false
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="containers-div" v-else>
        <div class="favourability-div card">
          <h3>Favourability</h3>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td colspan="2">
                  <h4 class="tone-class">Setup</h4>
                </td>
              </tr>
              <tr>
                <td>
                  Method
                </td>
                <td>
                  <input-select
                    id="method"
                    v-model="method"
                    :options="
                      favourability_methods.map(option => ({
                        value: option.id,
                        label: option.text
                      }))
                    "
                    :label="opt => favourability_methods.find(x => x.id == opt).text"
                    :show-labels="false"
                    :allowEmpty="true"
                    open-direction="bottom"
                    :searchable="true"
                    :selectedValue="method"
                    :onChange="onChangeSelectMethod"
                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr>
                <td>% Total Score</td>
                <td>
                  <input-text
                    :value="scoring_data.total_score"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'total_score' }"
                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr>
                <td>Fav Weight Increment</td>
                <td>
                  <input-text
                    :value="scoring_data.weight_increment"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'weight_increment' }"
                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
            </tbody>
          </table>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td colspan="2">
                  <h4 class="tone-class">Tone Multiplier</h4>
                </td>
              </tr>
              <tr>
                <td>Split</td>
                <td>
                  <input-select
                    :id="scoring_data.split"
                    v-model="scoring_data.split"
                    :searchable="true"
                    :options="
                      split_scoring.map(option => ({
                        value: option.id,
                        label: option.text
                      }))
                    "
                    :custom-label="opt => splitCustomLabel(opt)"
                    :show-labels="false"
                    :allowEmpty="false"
                    open-direction="bottom"
                    :selectedValue="scoring_data.split"
                    :onChange="onChangeSelectSplit"
                    />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true">
                <td>Positive</td>
                <td>
                  <input-text
                    :value="scoring_data.positive"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'positive' }"
                  />
                </td>
              </tr>
              <tr v-show="showSplitInputs == true && neutralSplit == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true && neutralSplit == true">
                <td>Neutral</td>
                <td>
                  <input-text
                    :value="scoring_data.neutral"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'neutral' }"
                  />
                </td>
              </tr>
              <tr v-show="hideSplitInputs == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="hideSplitInputs == true">
                <td>Balanced</td>
                <td>
                  <input-text
                    :value="scoring_data.balanced"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'balanced' }"
                  />
                </td>
              </tr>
              <tr v-show="showSplitInputs == true" class="separator">
                <td colspan="2"></td>
              </tr>
              <tr v-show="showSplitInputs == true">
                <td>Negative</td>
                <td>
                  <input-text
                    :value="scoring_data.negative"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'negative' }"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="scoring-constants card">
          <h3>Scoring Constants</h3>
          <table class="table-scoring">
            <tbody>
              <tr>
                <td>Multiplier</td>
                <td>
                  <input-text
                    :value="scoring_data.multiplier"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'multiplier' }"
                  />
                </td>
              </tr>
              <tr class="separator">
                <td colspan="2"></td>
              </tr>
              <tr>
                <td>Offset</td>
                <td>
                  <input-text
                    :value="scoring_data.offset"
                    id
                    placeholder="0"
                    class-names="input-scoring"
                    style-names="background: transparent;
                      text-align: right;
                      outline: 0;
                      border-width: 0 0 0 0px;
                      color: #ec9148;
                      width: 113px;
                      font-size: 13px;
                      height: 22px;"
                    @input="$emit('input', $event.target)"
                    @onEventBlur="updateInput"
                    :parameters="{ name: 'offset' }"
                  />
                </td>
              </tr>
              <template v-if="isCustomScoring">
                <tr class="separator">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td>Custom Scoring Label</td>
                  <td>
                    <input-text
                      :value="scoring_data.custom_label"
                      class-names="input-scoring"
                      placeholder="Label"
                      @input="$emit('input', $event.target)"
                      @onEventBlur="updateInput"
                      :parameters="{ name: 'custom_label' }"
                    />
                  </td>
                </tr>
                <tr class="separator">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td>Output Metric</td>
                  <td>
                    <input-select
                      v-model="outputMetric"
                      :options="outputMetricsOptions"
                      :show-labels="false"
                      :allowEmpty="false"
                      open-direction="bottom"
                      @change="(option) => updateSelect(option, 'output_metric')"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Custom Score Calculation</td>
                  <td>
                    <input-select
                      v-model="customScoreAvg"
                      :options="customScoringOptions"
                      :show-labels="false"
                      :allowEmpty="false"
                      open-direction="bottom"
                      @change="(option) => updateSelect(option, 'custom_score_avg')"
                    />
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

      </div>

      <div class="category-parameters card">
        <h3>Category Parameters</h3>
        <datatable v-if="isReady" v-bind:data="datatable" labelAdd="Add Categories" @create="addRow" />
      </div>

      <side-panel v-if="showMoreInformation == true" :onClose="closeSidePanel">
        <template>
          <h3>Theme - Setup Score Ranges </h3>
          <table class="tableSidePanel">
            <thead>
              <tr>
                <th>
                  <p>Count</p>
                </th>
                <th>
                  <p>Score %</p>
                </th>
                <th>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="item.count !== null || item.score !== null" v-for="(item, index) in edit_tag_count" :key="index">
                <td>
                  <input-text
                  :value="item.count"
                  style-names="background: transparent;
                  text-align: left;
                  outline: 0;
                  border-width: 0 0 0 0px;
                  color: #ec9148;
                  font-size: 13px;"
                  class="form__field"
                  v-model="item.count"
                  @input="$emit('input', $event.target)"
                  @onEventBlur="(e) => updateCount(e,item)"
                  :parameters="{ name: 'item.count' }" />
                </td>
                <td>
                  <input-text
                  :value="item.score"
                  style-names="background: transparent;
                  text-align: left;
                  outline: 0;
                  border-width: 0 0 0 0px;
                  color: #ec9148;
                  font-size: 13px;"
                  class="form__field"
                  v-model="item.score"
                  @input="$emit('input', $event.target)"
                  @onEventBlur="(e) => updateCount(e,item)"
                  :parameters="{ name: 'item.score' }" />
                </td>
                <td>
                  <span class="btn btn-carma btn-sm" @click="removeTagCount(item)">
                    <i class="fas fa-minus"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="actions-scoring">
            <span class="btn btn-default btn-sm" @click="addTagCount">
              <i class="fas fa-plus"></i> Add
            </span>
          </div>
        </template>
      </side-panel>
    </div>
  </load-content>
</template>

<script>
import DataTable from "../../components/datatable";
import { FIELD_TYPE, SCORING_METHODS, SCORING_OUTPUT_METRICS, CUSTOM_SCORE_METHODS } from "../../config/const";
import { propsForMixin } from "../../helpers/application";
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import InputText from "../form-components/input-text";
import InputSelect from "../form-components/input-select";
import InputButton from "../form-components/input-button-scoring";
import SidePanel from "../side-panel";
import {inputErrors} from "../../helpers/inputErrorHelper";
import LoadContent from "../load-content";

export default {
  name: "Scoring",
  components: {
    datatable: DataTable,
    InputText,
    InputSelect,
    SidePanel,
    LoadContent
  },
  created() {
    this.method = this.$store.state.projectSetup.projectSetup.data.scoring ? this.$store.state.projectSetup.projectSetup.data.scoring.method : null;
  },
  computed: {
    ...mapState({
      projectSetup: state => state.projectSetup.projectSetup,
      general: state => state.projectSetup.projectSetup.data ? state.projectSetup.projectSetup.data.general : [],
      categories: state => { const c = _.get(state.projectSetup.projectSetup.data, 'categories'); return c ? c.filter(c => c.include_in_score === true) : []},
      project: state => state.projects.project.data || {}
    }),
    favourability_methods() { return this.$store.getters['projectSetup/favourability_methods'] || []},
    split_scoring() { return this.$store.getters['projectSetup/split_scoring'] || []},
    edit_tag_count() {
      return [...this.editCategory.tag_count.filter(t => t != null)];
    },
    tag_count: {
      get () {
        let tags_count_category = this.$store.state.projectSetup.projectSetup.data.categories
        const x = tags_count_category.map(opt => {return opt.tag_count})
        return x;
      }
    },
    scoring_data: {
      get() {
        const scoring = _.get(this.$store.state.projectSetup.projectSetup.data, 'scoring');
        return scoring ? scoring : {};
        // const x = this.$store.state.projectSetup.projectSetup.data.scoring || {};
        // if(Object.keys(x).lenght > 0){
          
        //   this.showInputSplit(x.split) 
        // } 
        // return x;
      }
    },
    // method: {
    //   get() {
    //     const x = this.$store.state.projectSetup.projectSetup.data.scoring ? this.$store.state.projectSetup.projectSetup.data.scoring.method : '';
    //     return x;
    //   }
    // },
    category_methods: {
      get() {
        const x = this.$store.state.projectSetup.projectSetup.data
          .category_methods;
        return x;
      }
    },
    outputMetricsOptions() {
      const options = [{ value: null, label: this.$i18n.t('configuration.output_metrics.none') }];
      Object.keys(SCORING_OUTPUT_METRICS).forEach(key => {
        if (key !== "AVE" || (key === "AVE" && this.project.enable_ave === true)) {
          options.push({ value: SCORING_OUTPUT_METRICS[key], label: this.$i18n.t(`configuration.output_metrics.${SCORING_OUTPUT_METRICS[key]}`) })
        }
      });
      return options;
    },
    customScoringOptions() {
      const options = [];
      Object.keys(CUSTOM_SCORE_METHODS).forEach(key => {
          options.push({ value: CUSTOM_SCORE_METHODS[key], label: this.$i18n.t(`configuration.custom_score.${CUSTOM_SCORE_METHODS[key]}`) })
      });
      return options;
    },
    isCustomScoring() {
      return this.general.scoring == SCORING_METHODS.CUSTOM;
    }
  },
  watch: {
    categories: {
      handler(newCategories){
        this.datatable = Object.assign({}, this.datatable, {body: newCategories});
      },
      deep: true
    },
    scoring_data: {
      handler(scoring){
        this.method = scoring.method;
        this.outputMetric = scoring.output_metric;
        this.customScoreAvg = scoring.custom_score_avg ? CUSTOM_SCORE_METHODS.AVG : CUSTOM_SCORE_METHODS.SUM;
        Object.keys(scoring).length > 0 && this.showInputSplit(scoring.split, `split`);
      }
    },
    formErrors: {
      handler(value){
          value && import('vue').then(v => {
            v.default.notify({
              group: "store_notifications",
              type: "error",
              text: value
            })
          });
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      getprojectSetup: "projectSetup/getprojectSetup",
      updateProjectSetup: "projectSetup/updateProjectSetup",
      createCategories: "projectSetup/createCategories",
      deleteCategories: "projectSetup/deleteCategories",
      updateCategories: "projectSetup/updateCategories",
      updateScoring: "projectSetup/updateScoring",
      updateTagCount: "projectSetup/updateTagCount",
      createTagCount: "projectSetup/createTagCount",
      deleteTagCount: "projectSetup/deleteTagCount",
    }),

    splitCustomLabel: function(option) {
      const scoring = this.split_scoring.find(x => x.id == option);
      if (scoring) {
        return scoring.text;
      }
      return option.label;
    },

    openSidePanel: function(id, row) {
      this.editCategory = this.projectSetup.data.categories.find(c => c.id == id);
      this.showMoreInformation = true;
    },

    closeSidePanel: function() {
      this.showMoreInformation = false;
    },
    buildRenderOptions: function() {
      return {};
    },
    onChangeSelectMethod(option) {
      this.updateSelect(option, `method`);
    },
    onChangeSelectSplit(option) {
      this.updateSelect(option, `split`);
      this.showInputSplit(option)
    },
    showInputSplit(option, target) {      
      let payload = _.cloneDeep(this.$store.state.projectSetup.projectSetup.data);
      payload.scoring[target] = option;
      if (option == null || option == 0) {
        this.hideSplitInputs = false;
        this.showSplitInputs = false;
        this.neutralSplit = false;
      }
      if (option == 1) {
        // Option Three
        this.showSplitInputs = true;
        this.hideSplitInputs = false;
        this.neutralSplit = true;
      }
      if (option == 2) {
        // Option Four
        this.showSplitInputs = true;
        this.hideSplitInputs = true;
        this.neutralSplit = true;
      }
      if (option == 3) {
        // Option Two
        this.showSplitInputs = true;
        this.hideSplitInputs = false;
        this.neutralSplit = false;
      }
    },
    updateSelect(option, target) {
      let payload = _.cloneDeep(
        this.$store.state.projectSetup.projectSetup.data.scoring
      );
      payload[target] = option;
      const projectUid = this.projectUid;
      this.updateScoring({ payload, projectUid })
    },
    updateInput(valueInput) {              
        //inputErrors
        this.formErrors = null;        
        if (valueInput.name === "total_score") {
          this.formErrors = this.inputErrors(valueInput.value, "number_&_max_100", "% Total Score");
          if(!this.formErrors) this.formErrors = this.inputErrors( this.checkTotalSum(_.map(this.categories, (c) => c.percentage_score) ,valueInput.value), "number_&_max_100", this.totaScoreSumError);
        }   
        if (valueInput.name === "weight_increment") {
          this.formErrors = this.inputErrors(valueInput.value, "number_decimal", "Fav Weight Increment");
        }
        if (valueInput.name === "positive" || valueInput.name === "balanced" || valueInput.name === "neutral" || valueInput.name === "negative" || valueInput.name === "multiplier" || valueInput.name === "offset") {
          this.formErrors = this.inputErrors(valueInput.value, "number", (valueInput.name.charAt(0).toUpperCase() + valueInput.name.slice(1)));
        }
        
        if(!this.formErrors){
          let payload = _.cloneDeep(
            this.$store.state.projectSetup.projectSetup.data.scoring
          );
          payload[valueInput.name] = valueInput.value;
          const projectUid = this.projectUid;
          this.updateScoring({ payload, projectUid });
        }   
    },
    addRow() {
      this.datatable = Object.assign({}, this.datatable, {
        body: this.projectSetup.data.categories
      });

      let idProject;
      this.$store.dispatch("projectSetup/createCategories", idProject);
    },
    addTagCount() {
      const row = {
        count: 0,
        score: 0,
        cat_id: this.editCategory.id,
      }

      const projectUid = this.projectUid;
      this.createTagCount({ projectUid, row});

      // this.infoCount = this.infoCount.row.tag_count.filter(t => t != null);

      // let category = this.categoriesVariable.find(c => c.id == row.cat_id);
      // category.tag_count.push(row);
    },

    removeTagCount(row) {
      const data = {
        id: row.id,
        cat_id: this.editCategory.id
      }

      const projectUid = this.projectUid;
      this.deleteTagCount({ projectUid, row: data })
    },

    removeRow(row) {
      this.datatable = Object.assign({}, this.datatable, {
        body: this.projectSetup.data.categories
      });

      this.$store.dispatch("projectSetup/deleteCategories", row);
    },
    updateCount(e, row) {
      this.formErrors = null;
      const {name} = e;
      let [item, field] = String(name).split(".");
      
      if(field === "score"){
        this.formErrors = this.inputErrors(row.score, "number_decimal", "Score %");
      }

      if(field === "count"){
        this.formErrors = this.inputErrors(row.count, "number_decimal", "Count");
      }

      if (!this.formErrors) {
        const data = {
        ...row,
        cat_id: this.editCategory.id
        }
        const projectUid = this.projectUid;
        this.updateTagCount({ projectUid, row: data })
      }
    },
    updateRow(value, key, row) { 
      this.formErrors = null;
      if (key === "percentage_score") {
        this.formErrors = this.inputErrors(value, "number_&_max_100", "% Total Score");        
        if(!this.formErrors) this.formErrors = this.inputErrors(this.checkTotalSum(_.map(this.categories, (c) => c.id === row.id ? value: c.percentage_score) ,this.scoring_data.total_score), "number_&_max_100", this.totaScoreSumError)
      }   
      if(!this.formErrors){
        const newRow = _.cloneDeep(row);
        newRow[key] = value;
        const projectUid = this.projectUid;
        this.updateCategories({ projectUid, row: newRow });
      }
    },
    checkTotalSum(scores, total_score){
      return _(scores).compact().reduce((sum , c) => parseInt(c) + sum, parseInt(total_score));
    },

    inputErrors
  },
  data: function() {
    const projectUid = this.$route.params.project_uid;
    return {
      method: null,
      isReady: false,
      datatable: {},
      showSplitInputs: true,
      hideSplitInputs: false,
      showSidePanel: false,
      showMoreInformation: false,
      infoCount: {},
      infoTagCounts: {},
      projectUid,
      editCategory: null,
      formErrors: null,
      neutralSplit: false,
      totaScoreSumError: "All total score values summed",
      outputMetric: null,
      customScoreAvg: CUSTOM_SCORE_METHODS.AVG,
      // customLabel: null
    };
  },
  mounted: async function() {
    const projectUid = this.projectUid;
    this.getprojectSetup({ projectUid })
    .finally(function(){
      this.isReady = true;
    }.bind(this));
    const self = this;
    this.datatable = {
      custom_components: {
          'input-button-scoring': InputButton,
        },
      columns: [
        {
          key: "id",
          label: ""
        },
        {
          key: "name",
          label: "Name",
          input: {
            name: "name",
            type: FIELD_TYPE.INPUT,
            styleNames: { color: "#ec9148", border: "none", fontSize: '13px', outline: 'none' },
            placeholder: "Search",
            onBlur: function(value, key, row) {
              self.updateRow(value, key, row);
            }
          },
        disableKey: 'scoring_default'
        },
        {
          key: "method",
          label: "Method",
          style: { 'min-width': '200px' },
          input: {
            name: "method",
            type: FIELD_TYPE.SELECT,
            options: this.projectSetup.data.category_methods.map(option => ({
              value: option.id,
              label: option.method
            })),
            searchable: true,
            allowEmpty: false,
            preselectFirst: true,
            multiple: false,
            placeholder: "Select a method type",
            onChange: function(value, key, row) {
              self.updateRow(value, key, row);
            }
          },
          disableKey: 'scoring_default'
        },
        {
          key: "percentage_score",
          label: "% Total Score",
          input: {
            name: "percentage_score",
            type: FIELD_TYPE.INPUT,
            styleNames: { color: "#ec9148", border: "none", fontSize: '13px', outline: 'none' },
            placeholder: "0",
            onBlur: function(value, key, row) {
              self.updateRow(value, key, row);
            }
          },
          disableKey: 'scoring_default'
        },
        {
          key: '',
          label: 'Setup Score',
          input: {
            component: {
              name: 'input-button-scoring',
              getProps: function(row) {
                return {
                  ...row,
                  onClick: function(id) {
                    self.openSidePanel(id, row);
                  }
                }
              },
            },
          }
        }
      ],
      body: [],
      order: {
        column: "id",
        direction: "desc",
        onChange: function(column, direction) {
          self.fetch({ order: column, direction: direction });
        }
      }
    }
  },
  mixins: [propsForMixin]
};
</script>

<style scoped lang="scss">
@import '../../styles/components/coding-admin/_scoring.scss';
</style>
